const React = require("react")
// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {

    if(prevLocation && (location.pathname !== prevLocation.pathname)){
        window.dataLayer && window.dataLayer.push({'event':'dealermasters-quick-load'});
    }

    if (location.pathname === '/search/' || location.pathname === '/search') {
        const params = new URLSearchParams(location.search);
        if (!params.has('sort')) {
            params.set('sort', 'price-asc');
            window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
        }
    }
}
